"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// @ts-ignore
var react_symbol_1 = __importDefault(require("@wikom/react-symbol"));
var StaticErrorView = function () { return (react_1["default"].createElement("div", { className: "alert alert-danger", id: "page-alert-danger", role: "alert" },
    react_1["default"].createElement("h4", null,
        react_1["default"].createElement(react_symbol_1["default"], { symbol: { symbol: 'ban', className: 'icon' } }),
        "Ihr Browser konnte die Website oder Teile der Website nicht anzeigen. Bitte versuchen Sie es noch einmal.",
        react_1["default"].createElement("br", null),
        "Sollte das Problem weiterhin bestehen, k\u00F6nnte ein Update Ihres Browsers oder ein anderer Browser helfen.",
        react_1["default"].createElement("br", null),
        "Ansonsten kontaktieren Sie bitte den zust\u00E4ndigen Administrator.",
        react_1["default"].createElement("br", null)))); };
exports["default"] = StaticErrorView;
